import { render, staticRenderFns } from "./KvTownSelect.vue?vue&type=template&id=0fcc9e7f&scoped=true&"
import script from "./KvTownSelect.vue?vue&type=script&lang=js&"
export * from "./KvTownSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc9e7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcc9e7f')) {
      api.createRecord('0fcc9e7f', component.options)
    } else {
      api.reload('0fcc9e7f', component.options)
    }
    module.hot.accept("./KvTownSelect.vue?vue&type=template&id=0fcc9e7f&scoped=true&", function () {
      api.rerender('0fcc9e7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/KvTownSelect.vue"
export default component.exports